import * as _ from 'lodash';
import * as toastr from 'toastr';

import * as UserManagement from '../../';
import * as Common from '../../../../Common/modules';
import * as Models from '../../../../Models';
import * as Services from '../../../../Services';

export interface IUserManagementSearchCtrlScope {
  userManagementSearchTabCtrl: UserManagementSearchTabCtrl;
}

export class UserManagementSearchTabCtrl {
  private showLogging: boolean = false;
  private roleList: Models.Auth.RoleList.RoleList = new Models.Auth.RoleList.RoleList();
  public usersTabActive: boolean;
  public rolesTabActive: boolean;
  public groupsTabActive: boolean;
  public partnersTabActive: boolean;
  public shouldShowAdminTabs: boolean;

  public static $inject = ["$scope", "$state", "UserService"];

  constructor(
    $scope: IUserManagementSearchCtrlScope,
    private $state: angular.ui.IStateService,
    private userService: Services.UserService.IUserService,
  ) {
    $scope.userManagementSearchTabCtrl = this;
    // only user with manage user can do searches
    this.userService.isUserInRole(this.roleList.manageUsers).then((response) => {
      if (response === false) {
        this.$state.go("main.customersearchv2");
      }
    });

    this.usersTabActive = $state.includes("*.*.*.users");
    this.groupsTabActive = $state.includes("*.*.*.groups");
    this.rolesTabActive = $state.includes("*.*.*.roles");
    this.partnersTabActive = $state.includes("*.*.*.partners");

    if (!this.usersTabActive && !this.groupsTabActive && !this.rolesTabActive && !this.partnersTabActive) {
      this.usersTabActive = true;
    }

    // show admin tabs for admins
    this.shouldShowAdminTabs = false;
    this.userService.isUserInRole(this.roleList.manageUsersAdmin).then((response) => {
      if (response === true) {
        this.shouldShowAdminTabs = true;
      } else {
        this.shouldShowAdminTabs = false;
      }
    });
  }
}
